import { render, staticRenderFns } from "./ExampleScreen.vue?vue&type=template&id=50c73baa"
import script from "./ExampleScreen.vue?vue&type=script&lang=js"
export * from "./ExampleScreen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports